export default __webpack_public_path__ + "static/media/4.97231f74.jpg";